import { IApplicationData } from "./common";
export class SetAttribute implements IApplicationData {
  constructor() {
    this.name = "Set Variable";
    this.attribute = "";
  }
  name: string;
  attribute: string;
}
